import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from '@material-ui/core/styles';
import DialogContent from "@material-ui/core/DialogContent";
import { useDispatch } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import { DialogActions, Grid } from "@material-ui/core";
import Input from "Components/Input/Input";
import Translator from "Languages/Utility/Translator";
import * as R from "ramda";
import { read } from "Helpers/LocalStorage";
import { getAxFitting, getColorFitting, getDirectionFitting, updatePartLocal, updateStuffFitting } from "Stores/actions";
import showNotify from "Helpers/Notify";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import MuiButton from "Components/MuiButton/MuiButton";
import { useTranslation } from 'react-i18next';
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
import * as Icons from "react-bootstrap-icons";

function EditProduct({ row, idRangeTechnicalFitting, onClick }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [loading, setLoading] = useState(false);
  const [checkValid, setCheckValid] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [controls, setControls] = useSetState({
    count: {
      type: "number",
      value: 0,
      validation: {
          required: true,
          isNumeric: true,
          min: 0,
      },
    },
  });

  const handleDialog = () => {
    setOpenDialog(!openDialog);
  }

  const onEnter = async () => {
    setFormValid({ count: true });
    setControls({ count: { value: row.Count } });
  }

  const setValue = async (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  }

  const onFinish = async (e) => {
    e.preventDefault();
    if (!R.isEmpty(formValid) && Object.values(formValid).every((item) => item === true)) {
      const newValue = convertToEnglishNumber(controls.count.value);
      if(newValue > 0 && row.Count !== newValue) {
        try {
          setLoading(true);
          const data = {
            KeyUser: read("userKey"),
            KeyGroup: read("groupKey"),
            count: newValue,
            idRangeTechnicalFitting: idRangeTechnicalFitting,
            idStuffFitting: row.IdStuffFitting,
            id: row.Id,
          };
          const result = await dispatch(updatePartLocal(data));
          if(result) {
            showNotify({
              text: t('edit_stuff'),
              customClass: "success"
            });
            onClick();
            handleDialog();
          } else {
            showNotify({
              text: t('correctFormDataRequired'),
              customClass: "error",
            });
            setLoading(false);
          }
        } catch (e) {
          showNotify({
            text: t('correctFormDataRequired'),
            customClass: "error",
          });
          setLoading(false);
        }
      }
    } else {
      setCheckValid(true);
      showNotify({
        text: t('correctFormDataRequired'),
        customClass: "error",
      });
    }
  }

  return (
    <>
      <BackDropLoading loading={loading} />
      <ActionFormatter
          title={<Translator id="edit_stuffCount" />}
          icon={<Icons.Pencil size={17} />}
          className="warning-fill"
          onClick={handleDialog}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        TransitionProps={{
          onEnter: onEnter,
        }}
        fullWidth
        maxWidth="sm"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
              <Translator id={"edit_stuffCount"}/>
          </div>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item sm={6} xs={12} className="d-flex align-items-start">
                <p className="d-flex g-1 justify-content-center">
                  <>{t('name')}{":"}</>
                  <strong>{row.StuffFitting}</strong>
                </p>
              </Grid>
              <Grid item sm={6} xs={12} className="d-flex align-items-start">
                <p className="d-flex g-1 justify-content-center">
                  <>{t('standardCode')}{":"}</>
                  <strong>{row.StuffFittingCode}</strong>
                </p>
              </Grid>
              <Grid item xs={12}>
                <Input
                  setValue={setValue.bind(this)}
                  name={'count'}
                  placeholder={t('count')}
                  validation={controls['count'].validation}
                  label={<Translator id={'count'} />}
                  type="text"
                  checkValid={checkValid}
                  value={controls['count'].value}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
              color="primary"
              type="submit"
              title={<Translator id="button_save" />}
            />
            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default EditProduct;